import http from 'services/http-service';

const PartnerService = {
    GetSummary() {
        let response = http.get('/partners/summary');
        return response;
    },
    GetDailyCommissionChart() {
        let response = http.get('/partners/dailyCommissionChart');
        return response;
    },
    GetMonthlyCommissionChart() {
        let response = http.get('/partners/monthlyCommissionChart');
        return response;
    },
    GetBalanceHistory(skipCount: number, maxResultCount: number) {
        let response = http.get('/partners/balancehistories', { params: { skipCount: skipCount, maxResultCount: maxResultCount } });
        return response;
    },
    GetBalanceHistoryByPartnerId(partnerId: string, skipCount: number, maxResultCount: number) {
        let response = http.get(`/partners/${partnerId}/balancehistories`, { params: { skipCount: skipCount, maxResultCount: maxResultCount } });
        return response;
    },
    GetWithdraws(skipCount: number, maxResultCount: number) {
        let response = http.get('/partners/withdraws', { params: { skipCount: skipCount, maxResultCount: maxResultCount } });
        return response;
    },
    RequestWithdraw(amount: number, bankName: string, bankBranch: string, accountName: string, accountNumber: string, password: string) {
        let response = http.post('/partners/requestwithdraw', { amount, bankName, bankBranch, accountName, accountNumber, password });
        return response;
    },
    GetListWithdraw(status: number, skipCount: number, maxResultCount: number) {
        let response = http.get('/partners/adminwithdraws', { params: { status, skipCount, maxResultCount } });
        return response;
    },
    GetWithdraw(id: any) {
        let response = http.get('/partners/withdraws/' + id);
        return response;
    },
    TransferRequestWithdraw(partnerId: string, withdrawId: string, screenshot: any) {
        let formData = new FormData();
        formData.append("partnerId", partnerId);
        formData.append("withdrawId", withdrawId);
        formData.append("screenshot", screenshot);

        var result = http.post("/partners/transferwithdraw", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
        return result;
    },
    RejectRequestWithdraw(partnerId: string, withdrawId: string) {
        let response = http.post('/partners/rejectwithdraw', { partnerId, withdrawId });
        return response;
    },
    GetPartners(keyword: string, skipCount: number, maxResultCount: number) {
        let response = http.get('/partners', { params: { skipCount: skipCount, maxResultCount: maxResultCount, keyword: keyword } });
        return response;
    },
    Get(partnerId: any) {
        let response = http.get(`/partners/${partnerId}`);
        return response;
    },
    GetSales(partnerId: string, skipCount: number, maxResultCount: number) {
        let response = http.get(`/partners/${partnerId}/orders`, { params: { skipCount: skipCount, maxResultCount: maxResultCount } });
        return response;
    }
};

export default PartnerService;